import type { ExpenseCategory as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Expense from './Expense';

export type ExpenseCategory = {
  id: number;
  name: string;
  totalExpenses: number;
  variable: boolean;
  editable: boolean;
  expenses: Expense.Expense[];
};

export const fromGql = (item: GQLItem): ExpenseCategory => ({
  ...take<ExpenseCategory, GQLItem>(item, 'id', 'name', 'totalExpenses', 'variable', 'editable'),
  expenses: item.expenses ? item.expenses.map(Expense.fromGql) : [],
});
